import Chips from '../../../../Components/Dashboard/Chips';
import styles from './AthleteActivityCard.module.css';

const AthleteActivityToolbar = ({ counts, status, onStatus, sort, onSort, query, onQuery }) => (
    <div className={styles.toolbar}>
        <Chips
            label="Filter athletes"
            value={status}
            onChange={onStatus}
            options={[
                { key: 'all', label: 'All', count: counts.all },
                { key: 'active7', label: 'Active last 7 days', count: counts.active7 },
                { key: 'none', label: 'No completed workout', count: counts.none }
            ]}
        />
        <input
            type="text"
            className={styles.search}
            aria-label="Search athletes"
            placeholder="Search name or email"
            value={query}
            onChange={event => onQuery(event.target.value)}
        />
        <label className={styles.sortLabel}>
            Sort
            <select value={sort} onChange={event => onSort(event.target.value)}>
                <option value="recent">Most recent</option>
                <option value="oldest">Longest since</option>
            </select>
        </label>
    </div>
);

export default AthleteActivityToolbar;
